import _ from '@lodash';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useWorkflow } from '../../WorkflowProvider';
import TransformationPropertiesDialog from '../TransformationPropertiesDialog';
import { TransComponentTitleField, TransFeatureColumnField, TransInputKeyField, TransNameField, TransOutputKeysField, TransValidationIOKey, TransValidationName } from '../TransformationProperties';
import OutputMappingComponent from './OutputMappingComponent';
import { converter } from './FractionatingTransformation';

function FractionatingProperties(props) {
	const { data, showPropertiesDialog, transformationNameAvailable } = useWorkflow();
	const { t } = useTranslation('validation');
	const item = data.transform.find(d => d.key === showPropertiesDialog.key);

	const schema = yup.object().shape({
		name: TransValidationName(transformationNameAvailable, item.key),
		input_fields: TransValidationIOKey(),
		output_keys: yup.array().min(1, t('validation:AT_LEAST_ONE_REQUIRED')).required(t('FIELD_REQUIRED'))
	});

	return (
		<TransformationPropertiesDialog schema={schema} converter={converter} titleKey="fractionatingProperties">
			<TransNameField />
			<TransInputKeyField />
			<TransOutputKeysField />
			<OutputMappingComponent />
			<TransFeatureColumnField />
			<TransComponentTitleField />
		</TransformationPropertiesDialog>
	);
}

export default FractionatingProperties;
